import { render, staticRenderFns } from "./ISAInsightRoomTotalBedExit.vue?vue&type=template&id=361fcb65&scoped=true&"
import script from "./ISAInsightRoomTotalBedExit.vue?vue&type=script&lang=js&"
export * from "./ISAInsightRoomTotalBedExit.vue?vue&type=script&lang=js&"
import style0 from "./ISAInsightRoomTotalBedExit.vue?vue&type=style&index=0&id=361fcb65&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "361fcb65",
  null
  
)

export default component.exports